import { useQuery } from '@tanstack/react-query'
import { getShmpDashboard } from '@/services/shmpService'
import type { ShmpCourseNumber, ShmpDashboardData } from '@/types'

export function useShmpDashboard(params: {
  periodId: number | null
  weekNumber: number | null
  courseNumber: ShmpCourseNumber | null
}) {
  const query = useQuery<ShmpDashboardData, Error>({
    queryKey: ['shmp-dashboard', params.periodId, params.weekNumber, params.courseNumber],
    queryFn: () => getShmpDashboard({
      periodId: params.periodId as number,
      weekNumber: params.weekNumber,
      courseNumber: params.courseNumber,
    }),
    enabled: params.periodId !== null,
    staleTime: 60_000,
  })

  return {
    data: query.data ?? null,
    loading: query.isLoading,
    error: query.error?.message ?? null,
    refresh: query.refetch,
  }
}
